<script setup lang="ts">
    import type { PageProps, ProductPageProps } from '~/@types/generic';

    // https://nuxt.com/docs/guide/directory-structure/pages#catch-all-route

    // definePageMeta({
    //     // https://nuxt.com/docs/getting-started/routing#route-validation
    //     // maybe if we have fixed structure and we can split into content/product
    //     /*
    //      * (property) PageMeta.validate?: ((route: RouteLocationNormalized) => boolean | Promise<boolean> | Partial<NuxtError> | Promise<Partial<NuxtError>>) | undefined
    //      */
    // });

    const appStore = useAppStore();
    const nuxtApp = useNuxtApp();
    const { pageCache, pageStatus, pageError } = storeToRefs(appStore);
    const config = useRuntimeConfig();
    const route = useRoute();
    const { locale } = useLocales();
    const { previewEnabed } = usePreview();

    const url = computed(() => `/${Array.from(route.params.slug || []).join('/')}`);

    const loadPageData = async () => {
        await appStore.loadPageByUrl({
            locale: config.public.LOCALE_OVERRIDE || locale.value,
            url: url.value,
        });

        if (pageError.value && import.meta.server && nuxtApp.ssrContext?.event?.node?.res) {
            nuxtApp.ssrContext.event.node.res.statusCode = pageError.value.statusCode;
            nuxtApp.ssrContext.event.node.res.statusMessage = pageError.value.message;
        }
    };

    await callOnce(url.value, loadPageData, { mode: 'navigation' });

    const renderInfo = computed(() => {
        const page = pageCache.value?.page;
        const types = pageCache.value?.types || [];

        if (!page) return { type: undefined, data: pageCache.value };

        if (types.includes('ContentPage')) {
            return {
                type: 'ContentPage',
                data: pageCache.value as PageProps['pageData'],
            } as const;
        }

        if (types.includes('Product_Page') && page.product) {
            return {
                type: 'ProductPage',
                data: pageCache.value as ProductPageProps['pageData'],
            } as const;
        }

        return { type: undefined, data: pageCache.value };
    });

    const robots = computed(() => (previewEnabed.value ? 'none' : (pageCache.value?.seo?.robots ?? 'all')));
    useRobotsRule(robots);
</script>

<template>
    <atm-loader-bike
        v-show="pageStatus === 'pending'"
        is-page-loader />
    <mol-error
        v-if="pageError"
        :status-code="pageError.statusCode" />
    <lazy-renderer-content-page
        v-if="pageStatus === 'success' && renderInfo.type === 'ContentPage'"
        :page-data="renderInfo.data" />
    <lazy-renderer-product-page
        v-else-if="pageStatus === 'success' && renderInfo.type === 'ProductPage'"
        :page-data="renderInfo.data" />
</template>
